declare global {
  interface Window {
    ApplePaySession?: any;
  }
}

export const useCanUseApplePay = () => {
  return (
    // eslint-disable-next-line no-restricted-properties
    window.location.protocol === 'https:' &&
    !!window.ApplePaySession &&
    ApplePaySession.canMakePayments()
  );
};
